import { EBlockAlignment, EThemes } from '@/lib/contentstack-sdk/types';
import { OrFloorPlanViewer } from './or-floorplan-viewer';
import {
  IHomePlanBlueprint,
  IOrFloorPlanViewerCMSProps,
} from './or-floorplan-viewer.types';

export const OrFloorPlanViewerCMS = async (
  body: IOrFloorPlanViewerCMSProps,
) => {
  const {
    copy_block_content,
    theme,
    home_plan_id,
    floor_plans_pdf,
    copy_content_alignment,
    top_spacing,
    bottom_spacing,
  } = body;

  const fetchFloorPlans = async (): Promise<IHomePlanBlueprint[]> => {
    if (!home_plan_id?.select) {
      console.warn('No home_plan_id provided');
      return [];
    }

    try {
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_API_BASE_URL}/algolia/floor-plans?home_plan_id=${encodeURIComponent(home_plan_id.select)}`,
        {
          method: 'GET',
          next: { revalidate: 3600 },
        },
      );

      if (!response.ok) {
        console.error('Failed to fetch floor plans:', response.statusText);
        return [];
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching floor plans:', error);
      return [];
    }
  };

  const floorPlans = await fetchFloorPlans();

  const copyData = copy_block_content[0];

  const {
    uid,
    title,
    description,
    heading_element,
    link: ctaProps,
    heading_variant,
    alt_header,
    eyebrow,
    subhead,
    block_header: header,
  } = copyData;

  return (
    <OrFloorPlanViewer
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
      heading={{
        uid,
        title,
        heading_element,
        heading_variant,
        alt_header,
        header,
      }}
      description={description}
      subhead={subhead}
      eyebrow={eyebrow}
      ctaProps={ctaProps}
      blockAlignment={
        copy_content_alignment.alignmentprop as keyof typeof EBlockAlignment
      }
      blueprints={floorPlans}
      theme={theme.theme.toLocaleLowerCase() as EThemes}
      floorPlansPDF={floor_plans_pdf}
    />
  );
};
